export default __webpack_public_path__ + "static/media/STUDIOCOFFEE.5014e0a5.jpg";